<template>
  <div class="historical-agreement-list-box">
    <div class="list-title"><h2>历史版本</h2></div>
    <div class="list-content">
      <div v-for="item in list" :key="item.id" class="item-list">
        <a class="link" :href="item.linkUrl">{{item.title}}</a>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api";
import {isEmpty, isMobile} from '@/utilities/tools'

export default {
  name: "HistoricalAgreementList",
  data () {
    return {
      list: [],
      baseUrl: '/Rccl.UserCenter/HistoricalAgreementDetails'
    }
  },
  created () {
    const query = this.$router.currentRoute.query;
    if(!isMobile()) {
      window.location.href = `${process.env.VUE_APP_PC_URL}/Rccl.UserCenter/HistoricalAgreementDetails?${query}`;
      return;
    }
    let userAgreementType = "";
    let showMaxVersion = true;
    if (query && !isEmpty(query.type)) {
      if (isNaN(Number(query.type))) {
        return;
      } else {
        userAgreementType = Number(query.type);
      }
    }
    if (query && !isEmpty(query.showMaxVersion)) {
      if (query.showMaxVersion === 'true' || query.showMaxVersion === true) {
        showMaxVersion = Boolean(query.showMaxVersion)
      }
    }
    this.baseUrl = window.location.origin + this.baseUrl;
    this.initPage(userAgreementType, showMaxVersion)
  },
  methods: {
    async initPage (userAgreementType, showMaxVersion) {
      const { success, data, errMsg } = await api.user.getAgreeVersionNumberListByType({
        userAgreementType: userAgreementType,
        showMaxVersion: showMaxVersion
      })
      if (success) {
        this.list = this.formatRows(data) || [];
      } else {
        console.log(errMsg)
      }
    },
    formatRows(rows) {
      rows && rows.forEach(row => {
        row.linkUrl = `${this.baseUrl}?type=${row.type}&ver=${row.ver}&dateStr=${row.effectiveDateStr}&id=${row.id}`;
      });
      return rows;
    },
    toDetails(obj) {
      console.log(obj)
      this.$router.push({
        name: 'HistoricalAgreementDetails',
        query: {
          type: obj.type,
          ver: obj.ver,
          dateStr: obj.effectiveDateStr,
          id: obj.id
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.historical-agreement-list-box {
  width: 90%;
  margin: 0 auto;
  padding: 0 0 40px;
  & .list-title {
    text-align: center;
    width: 100%;
    & > h2 {
      margin-top: 25px;
      margin-bottom: 15px;
      font-size: 32px;
      font-weight: normal;
      color: #478cc7;
    }
  }
  & .list-content {
    margin-top: 20px;
    & .item-list {
      & + .item-list {
        margin-top: 15px;
      }
      & .title {
        color: #5a5a5a;
      }
      & .link {
        color: #337ab7;
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>